// extracted by mini-css-extract-plugin
export default {"container":"ban-info_container__gtW7R","header":"ban-info_header__AuNN2","info":"ban-info_info__aDVUg","line":"ban-info_line__ZB4YW","italic":"ban-info_italic__tugzQ"};